module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-6-b5ebae80e1f9bc1949f8f213917d024d.jpg";